module.exports = __WEBPACK_EXTERNAL_MODULE_openfl_errors_ArgumentError__;